// extracted by mini-css-extract-plugin
module.exports = {"grid":"info-grid_grid__pD3mk","item":"info-grid_item__NHSSA","info":"info-grid_info__3HjZe"};